// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"55d7919c","455":"84e4af45","644":"b4260999"}[chunkId] + ".chunk.js";
};